import { CLienteAPi } from "@sharedV11/classes/userRequest/client_api";


export class Request_items_motivos_group_list {
    ConexionIacpos: number;
    clienteAPI: CLienteAPi;
    Nombre: string;
    pkId: string;
    Descripcion: string;
}